import { AlignmentType } from 'docx'
import { createEmptyLine, DocxException } from '../docxFunctions'
import { createCommissionQuestionsTable } from '@/components/reportPresentation/allTables/createCommissionQuestionsTable'
import { createNumberedSectionHeading } from '@/components/reportPresentation/presentationSectionHeading'

export function createFourChapter(commission) {
  try {
    const table = createCommissionQuestionsTable(commission)
    if (!table) return []

    return [
      createEmptyLine(),
      createNumberedSectionHeading(6, 'ВОПРОСЫ ДЛЯ ЗАСЕДАНИЯ КОМИССИИ', {
        suffix: '',
        alignment: AlignmentType.LEFT,
      }),
      createEmptyLine(),
      table,
    ]
  } catch (err) {
    throw new DocxException(6, err.message)
  }
}
